import { ReactElement } from 'react';
import Alert from '@mui/material/Alert';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

/**
 * Card for displaying navigation options
 * @param {string} title
 * @param {ReactElement} icon
 * @param {string} role
 * @param {string} description
 * @param {ReactElement} navigation
 * @returns navigation display
 */
const NavCard = ({
	title,
	icon,
	role,
	description,
	navigation,
	messages = [],
}) => {
	return (
		<Card
			variant='outlined'
			sx={{ width: 400, minHeight: 150, m: 1, flexGrow: 1 }}
		>
			<CardContent>
				<Stack direction='row' alignItems='center' gap={1}>
					{icon}
					<Typography variant='h5' component='div'>
						{title}
					</Typography>
				</Stack>
				<Typography sx={{ mb: 1.5 }} color='text.secondary'>
					{role}
				</Typography>
				<Typography variant='body2'>{description}</Typography>
				{messages.map(({ type, message }) => (
					<Alert severity={type}>{message}</Alert>
				))}
			</CardContent>
			<CardActions>{navigation}</CardActions>
		</Card>
	);
};

export default NavCard;
